module.exports = __webpack_public_path__ + "static/media/wavm8s-010-kattie.6023049.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/wav/wavm8s-010-kattie.mp3
// module id = HksX
// module chunks = 0